// coursePermissions.js — sursa unică de adevăr (frontend) pentru ce tipuri
// de cursuri poate atribui/crea fiecare utilizator. Identic cu backend-ul.

const ALL_SSM = ['IIG_SSM', 'ILM_SSM', 'IP_SSM', 'SUPLIMENTARE_SSM'];
const ALL_SU = ['IIG_SU', 'ILM_SU', 'IP_SU'];
const CLM_ALLOWED = ['ILM_SSM', 'ILM_SU', 'IP_SSM', 'IP_SU', 'SUPLIMENTARE_SSM'];

/**
 * Returnează un Set cu tipurile de cursuri permise.
 */
export const getAllowedCourseTypes = (user, isCLM = false) => {
  const allowed = new Set();
  if (!user) return allowed;

  if (user.role === 'SUPER_ADMIN') {
    [...ALL_SSM, ...ALL_SU].forEach((t) => allowed.add(t));
    return allowed;
  }

  if (user.role === 'SSM_INSTRUCTOR') {
    ALL_SSM.forEach((t) => allowed.add(t));
  }

  if (user.isSSMInstructor) {
    ALL_SSM.forEach((t) => allowed.add(t));
  }

  if (user.isCadruTehnicPSI) {
    ALL_SU.forEach((t) => allowed.add(t));
  }

  if (isCLM) {
    CLM_ALLOWED.forEach((t) => allowed.add(t));
  }

  return allowed;
};

/**
 * Verifică dacă userul poate atribui (cel puțin un tip).
 */
export const canAssignAnyCourse = (user, isCLM = false) => {
  return getAllowedCourseTypes(user, isCLM).size > 0;
};

export const canAssignType = (user, isCLM, courseType) => {
  return getAllowedCourseTypes(user, isCLM).has(courseType);
};

// Roluri care pot crea orice tip de instruire (match backend course.controller.js).
const CREATE_ANY_TYPE_ROLES = new Set(['SUPER_ADMIN', 'SSM_COMPANY_ADMIN', 'SSM_INSTRUCTOR']);

/**
 * Tipuri de instruiri pe care userul le poate CREA (din CourseForm).
 * Diferă de getAllowedCourseTypes (care e pentru atribuire):
 *  - SSM_COMPANY_ADMIN și SSM_INSTRUCTOR primesc toate tipurile la creare,
 *    chiar dacă la atribuire au restricții (per backend course.controller.js).
 *  - Alte roluri intră pe regula de atribuire (bife + CLM).
 */
export const getCreatableCourseTypes = (user, isCLM = false) => {
  if (user && CREATE_ANY_TYPE_ROLES.has(user.role)) {
    return new Set([...ALL_SSM, ...ALL_SU]);
  }
  return getAllowedCourseTypes(user, isCLM);
};
